import(/* webpackMode: "eager" */ "/usr/src/app/training-portal/src/app/loading.tsx")